import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=47c545cc"
import script from "./Highlights.vue?vue&type=script&lang=ts"
export * from "./Highlights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c545cc')) {
      api.createRecord('47c545cc', component.options)
    } else {
      api.reload('47c545cc', component.options)
    }
    module.hot.accept("./Highlights.vue?vue&type=template&id=47c545cc", function () {
      api.rerender('47c545cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/Highlights.vue"
export default component.exports